"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionTier = exports.SilverPurchase = void 0;
var SilverPurchase;
(function (SilverPurchase) {
    SilverPurchase["MorePotions"] = "MorePotions";
    SilverPurchase["MoreCharacters"] = "MoreCharacters";
    SilverPurchase["ExpandedMaterialStorage"] = "ExpandedMaterialStorage";
    SilverPurchase["SharedLockers"] = "SharedLockers";
    SilverPurchase["MagicPouch"] = "MagicPouch";
    SilverPurchase["FestivalXP"] = "FestivalXP";
    SilverPurchase["FestivalSkill"] = "FestivalSkill";
    SilverPurchase["CosmeticInversify"] = "CosmeticInversify";
    SilverPurchase["CosmeticAncientify"] = "CosmeticAncientify";
    SilverPurchase["CosmeticEtherPulse"] = "CosmeticEtherPulse";
    SilverPurchase["CosmeticGhostEther"] = "CosmeticGhostEther";
})(SilverPurchase || (exports.SilverPurchase = SilverPurchase = {}));
var SubscriptionTier;
(function (SubscriptionTier) {
    SubscriptionTier[SubscriptionTier["None"] = 0] = "None";
    SubscriptionTier[SubscriptionTier["Trial"] = 1] = "Trial";
    SubscriptionTier[SubscriptionTier["Basic"] = 5] = "Basic";
    SubscriptionTier[SubscriptionTier["Tester"] = 2] = "Tester";
    SubscriptionTier[SubscriptionTier["GM"] = 10] = "GM";
})(SubscriptionTier || (exports.SubscriptionTier = SubscriptionTier = {}));
